<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>لیست کالا های ارسالی</strong>
              </CCol>
              <CCol style="text-align: end;">
                <CButton
                        class="mr-1"
                        size="sm"
                        @click="print_with_header('print_report_buy','print_report_header','print_report_footer')"
                        color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
                  <CButton v-if="items_sell.length" @click="add_sell_factor()" outline color="primary" size="sm">ثبت حواله فروش</CButton>

              </CCol>

            </CRow>

          </CCardHeader>
          <div v-show="false">
            <div id="print_report_header" class="border-dark">
              <CCardHeader>
                <CRow style="border: 1px solid #000">

                  <CCol sm="4" md="4" style="text-align: right">
                    <h2 >{{ get_date(new Date()) }}</h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: center">
                    <h2>لیست کالا های ارسالی</h2>

                  </CCol>
                  <CCol sm="4" md="4" style="text-align: left">
                    <CImg :src="get_logo()" width="100px" height="50px"/>

                  </CCol>
                </CRow>

              </CCardHeader>

            </div>
            <div id="print_report_footer" class="border-dark">
              <CCardHeader>
                <CRow style="border: 1px solid #000">
                  <CCol sm="4" md="4" style="text-align: start">
                    <h2>{{$t('docCreator')}} : {{ get_user_name() }}</h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: center">
                    <h2 id="pageFooter" class="pageFooter"></h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: end">
                    <h2>

                    </h2>
                  </CCol>
                </CRow>

              </CCardHeader>

            </div>

          </div>
          <CCardBody id="print_report_buy">

                  <CCol sm="6" md="4">
                    <CSelect :value.sync="selected_driver"
                             :options="driver_items"
                    />
                  </CCol>
            <CDataTable
                :items="items_sell"
                :fields="fields"
                column-filter

                :items-per-page="20"
                hover
                sorter
                border
                striped
                :sorter-value="{column:'recId',asc:false}"
                pagination
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p>{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #createdAt="{item}">

                <td>
                  <p>{{ get_date(item.createdAt) }}</p>

                </td>

              </template>

              <template #warehouse="{item}">
                <td>
                  <p>{{ item.placeName }}</p>

                </td>

              </template>
              <template #price="{item}">

                <td>
                  <p>{{ item.totalPrice }}</p>

                </td>


              </template>
              <template #customer="{item}">

                <td>
                  <p>{{ item.partyName }}</p>

                </td>

              </template>
              <template #toziKonande="{item}">

                <td>
                  <p v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>

                </td>

              </template>
              <template #user="{item}">

                <td>
                  <p>{{ item.createdBy }}</p>

                </td>

              </template>


              <template #operation="{item}">
                <td>
                  <!--                      <CButton v-if="item.statusId !=0"-->
                  <!--                               color="primary"-->
                  <!--                               variant="outline"-->
                  <!--                               square-->
                  <!--                               :title="$t('buttons.returnDocument')"-->
                  <!--                               size="sm"-->
                  <!--                               @click="goReturnDocument(item)"-->
                  <!--                      >-->
                  <!--                        <CIcon name="cilTransfer"/>-->
                  <!--                      </CButton>-->
                  <!--                      <CButton-->
                  <!--                          class="m-1"-->
                  <!--                          color="primary"-->
                  <!--                          variant="outline"-->
                  <!--                          square-->
                  <!--                          :title="$t('buttons.show')"-->
                  <!--                          size="sm"-->
                  <!--                          @click="goShowDocument(item)"-->
                  <!--                      >-->
                  <!--                        <CIcon name="cil-speedometer"/>-->
                  <!--                      </CButton>-->
                  <!--                      <CButton-->
                  <!--                          class="m-1"-->
                  <!--                          color="success"-->
                  <!--                          square-->
                  <!--                          size="sm"-->
                  <!--                          :title="$t('buttons.print')"-->
                  <!--                          @click="goPrintDocument(item)"-->
                  <!--                      >-->
                  <!--                        <CIcon name="cil-print"/>-->
                  <!--                      </CButton>-->
                  <!--                      <CButton v-if="item.statusId !=0 && item.toziKonande==null"-->
                  <!--                               class="m-1"-->
                  <!--                               color="primary"-->
                  <!--                               variant="outline"-->
                  <!--                               square-->
                  <!--                               :title="$t('buttons.refer')"-->
                  <!--                               size="sm"-->
                  <!--                               @click="AddRefer(item)"-->
                  <!--                      >-->
                  <!--                        <CIcon name="cilShare"/>-->
                  <!--                      </CButton>-->

                  <!--                      <CButton v-if="item.statusId ==0"-->
                  <!--                               class="m-1"-->
                  <!--                               color="primary"-->
                  <!--                               square-->
                  <!--                               size="sm"-->
                  <!--                               :title="$t('buttons.finalize')"-->
                  <!--                               @click="Finalize(item)"-->
                  <!--                      >-->
                  <!--                        <CIcon name="cil-https"/>-->
                  <!--                      </CButton>-->

                  <CButton v-if="item.statusId ==0"

                           size="sm"
                           :title="$t('buttons.finalize')"
                           @click="Finalize(item)"
                  >
                    <CIcon name="cil-trash" class="text-danger"/>
                  </CButton>
                </td>
              </template>

              <template #select="{item}">
                <td>

                  <CCol v-if="item.statusId !=0 && item.toziKonande==null">

                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                           :value="item.recId"/>

                  </CCol>

                </td>
              </template>
            </CDataTable>
          </CCardBody>


        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',


      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_driver: 0,
      driver_items: [],
      items_sell: [],
      table_clicks_timer: '',
      table_clicks: 0,

      fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'productName', label: this.$t('tables.name'), _style: 'width:15%'},

        // {key: 'recId', label: this.$t('tables.number'), _style: 'width:2%'},
        {key: 'productCode', label: this.$t('tables.code'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:10%'},
        // {key: 'customer', label: this.$t('supplier'), _style: 'width:20%'},
        // {key: 'user', label: this.$t('createdBy'), _style: 'width:15%'},

        // {key: 'price', label: this.$t('tables.totalAmount'), _style: 'width:10%'},


        // {key: 'انبار', _style: 'width:10%'},
        // {key: 'statusPay', label: this.$t('tables.status'), _style: 'width:10%'},
        // {key: 'routeName', label: this.$t('route'), _style: 'width:10%'},
        // {key: 'mobile', label: "شهرستان", _style: 'width:20%'},

        {key: 'operation', label: "", _style: 'width:5%;', sorter: false, filter: false},
        // {key: 'select', label: this.$t('tables.select'),},

      ],

      status_form: 0,

    }
  }, mounted() {

    this.start_date = this.get_day_before_today_in_day(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
    this.get_driver_lists();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.person_id': function () {
      this.get_all_data();
    },
    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_driver_lists();
    },
    'selected_driver': function () {
      this.get_all_data();

    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.goShowDocument(item)

      }

    },
    get_all_data() {
      this.get_lists_sell();

    },

    get_lists_sell() {

      var self = this;


      const formData = new FormData();
      var url = "GetFactorSupplierForReferred";
      // formData.append("SupplierId", localStorage.getItem('user_id'));
      formData.append("SupplierId", 11);

      formData.append("DriverId", self.selected_driver);
      axios.post(url, formData, {}).then(function (response) {
        var content_data = response.data;
        if (content_data.statusCode == 0) {
          self.items_sell = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_driver_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetDistributorUsers', formData, {}).then(function (response) {

        var content_data = response.data;
        self.driver_items=[{label:'انتخاب کنید',value:0}]
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.driver_items = self.sort_array(self.driver_items,content_data.data,'personId','personName');
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_sell_factor() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      formData.append("SupplierId", 11);

      formData.append("DriverId", self.selected_driver);
      axios.post('AddFactorSupplierReferred', formData, {}).then(function (response) {


          self.$root.modal_component.show_api_response_modals(response);
        self.get_lists_sell();

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  },

}

</script>
